<template>
  <!-- 富文本 -->
  <div>
    <editor v-model="content" :init="init" :disabled="disabled"></editor>
  </div>
</template>

<script>
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/icons/default/icons";
import "tinymce/themes/silver";
import "tinymce/plugins/image";
import "tinymce/plugins/media";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/contextmenu";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/colorpicker";
import "tinymce/plugins/textcolor";
import "tinymce/plugins/preview";
import "tinymce/plugins/code";
import "tinymce/plugins/link";
import "tinymce/plugins/advlist";
import "tinymce/plugins/codesample";
import "tinymce/plugins/hr";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/textpattern";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/autolink";
import "tinymce/plugins/directionality";
import "tinymce/plugins/visualblocks";
import "tinymce/plugins/visualchars";
import "tinymce/plugins/template";
import "tinymce/plugins/charmap";
import "tinymce/plugins/nonbreaking";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/imagetools";
import "tinymce/plugins/autosave";
import "tinymce/plugins/autoresize";
import { DOMUtils } from "tinymce";

export default {
  components: {
    Editor
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    plugins: {
      type: [String, Array],
      default:
        "preview searchreplace autolink directionality visualblocks visualchars fullscreen image link template code codesample table charmap hr nonbreaking insertdatetime advlist lists wordcount imagetools textpattern autosave autoresize"
    },
    toolbar: {
      type: [String, Array],
      default:
        "undo redo | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link | alignleft aligncenter alignright alignjustify outdent indent formatpainter | \
      formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | \
      table image charmap hr pagebreak insertdatetime | fullscreen "
    },
    emailGroupId: {
      type: Number,
      // 默认是全员公告
      default: 0
    },
    asqmsFlag: {
      type: Boolean,
      // asqms
      default: false
    }
  },
  data() {
    return {
      //初始化配置
      init: {
        menubar: false, // 菜单栏显隐
        language_url: "/static/tinymce/langs/zh_CN.js",
        //language_url: '../../static/tinymce/langs/zh_CN.js', // vue-cli2.x
        language: "zh_CN",
        skin_url: "/static/tinymce/skins/ui/oxide",
        //skin_url: '../../static/tinymce/skins/ui/oxide', // vue-cli2.x
        //content_css: '../../static/tinymce/skins/content/default/content.css',// vue-cli2.x
        height: 400,
        min_height: 400,
        max_height: 770,
        toolbar_mode: "wrap",
        plugins: this.plugins,
        toolbar: this.toolbar,
        content_style: "p {margin: 5px 0;}",
        //  img{max-width: 660px;width: 100%;height:auto;}
        fontsize_formats: "12px 14px 16px 18px 24px 36px 48px 56px 72px",
        font_formats: "宋体=simsun;仿宋体=FangSong;黑体=SimHei;sans-serif;",
        branding: false,
        // 图片上传
        images_upload_handler: this.imgUpload,
        // 解决粘贴图片后，不自动上传，而是使用base64编码。
        urlconverter_callback: (url, node, onSave, name) => {
          if (node === "img" && url.startsWith("blob:")) {
            // Do some custom URL conversion
            // console.log("urlConverter:", url, node, onSave, name);
            tinymce.activeEditor && tinymce.activeEditor.uploadImages();
          }
          // Return new URL
          return url;
        },
        paste_data_images: true
      },
      content: this.value
    };
  },
  mounted() {
    tinymce.init({});
  },
  // <h1 id="activity-name" class="rich_media_title ">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; @工厂企业，14项消防安全提示要记牢！</h1>
  methods: {
    imgUpload(blobInfo, success, failure) {
      if (blobInfo.blob().size > 10485760) {
        failure("上传图片尺寸大小不能超过10MB!");
      }
      console.log(blobInfo.blob());
      console.log(
        "🚀 ~ file: imcoder-tinymce.vue:145 ~ imgUpload ~ blobInfo.blob()",
        blobInfo.blob().size
      );
      let url = "/api/common/noticeUploadFile"; // 这个地址是请求接口的一个映射
      if (this.$props.asqmsFlag){
        url = "/api/asqmsUpload/newsAnncmntImg";
      }
      const formData = new FormData(); // 和后端协商后用formData格式进行传参
      formData.append("addFiles", blobInfo.blob());
      // 当前用户id
      formData.append("userId", localStorage.getItem("userId"));
      // 创建用户的ID
      formData.append("creatUser", localStorage.getItem("userId"));
      // 群公告ID（0:全员公告）
      formData.append(
        "emailGroupId",
        this.emailGroupId ? this.emailGroupId : 0
      );
      // formData.append("fileType", "noticeFile");
      // formData.append("authorization", getToken());
      this.$http
        .post(url, formData)
        .then(res => {
          // console.log(res);
          if (res.data.code === 200) {
            // console.log(
            //   "🚀 ~ file: imcoder-tinymce.vue:160 ~ imgUpload ~ res.data.data",
            //   res.data.data
            // );
            // success(res.data.data);
            // 动态创建img标签，如果不创建则拿不到图片的宽高
            // const img = document.createElement("img");
            // img.src = res.data.data;
            // console.log(
            //   "🚀 ~ file: imcoder-tinymce.vue:192 ~ imgUpload ~ img:",
            //   img
            // );
            // img.onload = () => {
            //   console.log("img.naturalHeight", img.naturalHeight);
            //   console.log("img.naturalWidth", img.naturalWidth);
            //   // 等图片加载完成之后等比例缩放图片，宽度最大660
            //   if (img.naturalWidth > 660) {
            //     const scale = img.naturalWidth / 660;
            //     // 按比例算出宽度最大660的图片宽度
            //     const height = (img.naturalHeight / scale).toFixed(0);
            //     const width = 660;
            //     const style = `style="width:${width}px;height:${height}px;"`;
            //     // 通过tinymce的execCommand方法将生成的img标签插入到富文本中
                success(res.data.data);
            //     tinymce.execCommand(
            //       "mceInsertContent",
            //       false,
            //       `<img src=${res.data.data}  ${style}/><br/>`
            //     );
            //     callbalk();
            //   }
            // };
          }
        })
        .catch(err => {
          failure("出现未知问题，请刷新页面!");
          console.log(err);
        });
    },
    preprocessingContent(content) {
      content = content.trim();
      let reg = /(<h1 id="activity-name" class="rich_media_title ">)(&nbsp; )+(.*?<\/h1>)/;
      content = content.replace(reg, "$1$3");
      while (content.indexOf('crossorigin="anonymous"') !== -1) {
        content = content.replace('crossorigin="anonymous"', "");
      }
      return content;
    }
  },
  watch: {
    value(newValue) {
      // console.log("before", newValue);
      this.content = this.preprocessingContent(newValue);
      // console.log("after", this.content);
      // this.content = newValue
      this.value = this.content;
    },
    content(newValue) {
      this.$emit("input", newValue);
    }
  }
};
</script>
<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/imcoder-tinymce.vue